const FormValidation = {
  SUCCESS: 'success',
  ERROR: 'danger',
  WARNING: 'warning',
  PENDING: 'pending',
};

export default FormValidation;
